import { render, staticRenderFns } from "./ProjectPerformance.vue?vue&type=template&id=85ff1630&"
import script from "./ProjectPerformance.vue?vue&type=script&lang=js&"
export * from "./ProjectPerformance.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPerformance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports